import { all, AllEffect } from 'redux-saga/effects';
import AppointmentsReducer from './duck/reducer';
import { watchGetAppointments } from './duck/saga';

function* AppointmentsSaga(): Generator<AllEffect<Generator>> {
  yield all([watchGetAppointments()]);
}

export { AppointmentsReducer, AppointmentsSaga };
